import { Directive } from '@angular/core';
import { ProductComponentBase } from '../../ProductComponentBase';
import {
  ProductDetailRenderTarget,
  ProductDetailRenderTargetComponents,
} from './product-detail-layout/render-targets/ProductDetailRenderTarget';

export enum ProductDetailComponentLayoutSize {
  Small,
  Medium,
  Large,
  ExtraLarge,
}

@Directive()
export abstract class ProductDetailLayoutComponentsProviderComponentBase extends ProductComponentBase {
  protected readonly LayoutTargets = ProductDetailRenderTarget;
  protected readonly LayoutComponents = ProductDetailRenderTargetComponents;
}
